export default __webpack_public_path__ + "static/media/logout.b382cc9b.svg";